import { duration } from "common";
import dayjs from "dayjs";
import durationPlugin from "dayjs/plugin/duration";
import { QueryClient } from "react-query";

dayjs.extend(durationPlugin);

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: duration(24, "hours"),

            cacheTime: duration(1, "week"),

            // When a useQuery query fails (the query function throws an error),
            // React Query will automatically retry the query.
            // Setting the value to `false` disables any retries.
            retry: false,

            // Prevent the fetching when window is focused again.
            refetchOnWindowFocus: false,
        },
    },
});
